
import React from 'react';

import { useFilter, useStore } from '../../../hooks';
import FilterItem from './FilterItem';
import { AVAILABLE_FILTERS } from './Filters.constants';
import { StyledFiltersList, StyledFiltersPanel } from './Filters.styled';

const Filters = () => {
  const { originalImage, shownImageDimensions } = useStore();
  const [appliedFilter, applyFilter] = useFilter();

  return (
    <StyledFiltersPanel className="respark_filters-panel effects-filters-wrap">
      <StyledFiltersList className="effects-filters-list">
        {AVAILABLE_FILTERS.map((filter) => (
          <FilterItem
            key={filter.label}
            filterLabel={filter.label}
            filterFn={filter.filterFn}
            applyFilter={applyFilter}
            isActive={appliedFilter === filter.filterFn}
            image={originalImage}
            shownImageDimensions={shownImageDimensions}
          />
        ))}
      </StyledFiltersList>
    </StyledFiltersPanel>
  );
};

export default Filters;
